import { render, staticRenderFns } from "./Sora2VideoModelSeo.vue?vue&type=template&id=6f7c3e2a&scoped=true"
import script from "./Sora2VideoModelSeo.vue?vue&type=script&lang=js"
export * from "./Sora2VideoModelSeo.vue?vue&type=script&lang=js"
import style0 from "./Sora2VideoModelSeo.vue?vue&type=style&index=0&id=6f7c3e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c3e2a",
  null
  
)

export default component.exports